import { hotTags } from '@/mocks/gossip';

const stats = [
  { num: '28w+', label: '围观吃瓜粉丝' },
  { num: '4.6w', label: '今日参与投票' },
  { num: '1.2k+', label: '本周上头条来稿' },
];

export default function Hero() {
  return (
    <section
      id="top"
      className="relative flex min-h-[640px] md:min-h-[720px] w-full items-center overflow-hidden"
    >
      <img
        src="https://readdy.ai/api/search-image?query=Abstract%20modern%20editorial%20newspaper%20collage%20with%20bold%20red%20headline%20bars%2C%20mega%20phone%20and%20megaphone%20icons%2C%20warm%20orange%20and%20cream%20ink%20splashes%2C%20floating%20speech%20bubbles%20and%20stars%2C%20high%20contrast%20stylized%20vector%20illustration%2C%20dark%20vintage%20red%20background%2C%20cinematic%20and%20playful%20gossip%20news%20mood&width=1800&height=1100&seq=chigua-hero&orientation=landscape"
        alt="吃瓜日报主视觉背景插画"
        className="absolute inset-0 h-full w-full object-cover"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-primary-950/70 via-primary-900/40 to-primary-950/80"></div>

      <div className="relative mx-auto w-full max-w-5xl px-4 md:px-8 py-24 md:py-28 text-center">
        <span className="inline-flex items-center gap-2 rounded-full bg-background-50/15 px-4 py-1.5 text-xs font-semibold tracking-wide text-background-50 ring-1 ring-background-50/30 backdrop-blur">
          <i className="ri-vip-crown-fill text-accent-300" aria-hidden="true"></i>
          今日吃瓜现场 · 持续更新中
        </span>

        <h1 className="mt-6 font-heading text-4xl md:text-6xl font-black leading-tight tracking-tight text-background-50 text-balance">
          全网热瓜
          <span className="mx-2 inline-block rotate-3 bg-accent-500 px-2 text-primary-950">一站开聊</span>
        </h1>
        <p className="mx-auto mt-6 max-w-2xl text-base md:text-lg leading-relaxed text-background-100">
          在<strong className="font-semibold text-accent-300">吃瓜日报</strong>
          ，每日热榜由你投票定胜负，最新鲜的瓜圈资讯随刷随到。发表你的评论，或私信投稿分享独家爆料——
          认真吃瓜的你，声音也能上头条。
        </p>

        <div className="mt-8 flex flex-col sm:flex-row items-center justify-center gap-3">
          <a
            href="#hot"
            className="whitespace-nowrap inline-flex w-full sm:w-auto items-center justify-center gap-2 rounded-md bg-primary-500 px-6 py-3 text-sm font-semibold text-background-50 transition-colors hover:bg-accent-500"
          >
            <i className="ri-fire-fill" aria-hidden="true"></i>看今日热榜
          </a>
          <a
            href="#submit"
            className="whitespace-nowrap inline-flex w-full sm:w-auto items-center justify-center gap-2 rounded-md bg-background-50/15 px-6 py-3 text-sm font-semibold text-background-50 ring-1 ring-background-50/40 backdrop-blur transition-colors hover:bg-background-50/25"
          >
            <i className="ri-send-plane-fill" aria-hidden="true"></i>我要投稿上头条
          </a>
        </div>

        <div className="mt-10 flex flex-wrap items-center justify-center gap-2">
          <span className="text-xs text-background-100/80">热门词：</span>
          {hotTags.map((t) => (
            <span
              key={t}
              className="rounded-full bg-background-50/12 px-3 py-1 text-xs text-background-100 ring-1 ring-background-50/25"
            >
              # {t}
            </span>
          ))}
        </div>

        <dl className="mx-auto mt-12 grid max-w-3xl grid-cols-1 sm:grid-cols-3 gap-4 rounded-2xl bg-primary-950/30 p-5 ring-1 ring-background-50/20 backdrop-blur">
          {stats.map((s) => (
            <div key={s.label} className="text-center sm:border-l sm:first:border-l-0 sm:border-background-50/15">
              <dd className="font-heading text-2xl md:text-3xl font-black text-accent-300">{s.num}</dd>
              <dt className="mt-1 text-xs md:text-sm text-background-100/85">{s.label}</dt>
            </div>
          ))}
        </dl>
      </div>
    </section>
  );
}